import { useGetSubscriptionQuery } from 'store/api/yay/payment'
import { useCurrentUser } from 'store/api/yay/user'

export const useUserSubscriptionSetting = () => {
  const isVip = useCurrentUser()?.data?.vip
  const vipUntil = useCurrentUser()?.data?.vip_until

  return { isVip, vipUntil }
}

export const useAutoRenewal = () => {
  const { data: currentSubscription } = useGetSubscriptionQuery()

  const noNextPlan = !!currentSubscription?.canceled_date
  const hasCancelPeriod = Boolean(!currentSubscription?.canceled_date)

  return {
    isDisabled: noNextPlan && hasCancelPeriod,
  }
}
